import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface MyNav {
  is_manager: boolean;
  is_executive: boolean;
  was_asked: boolean;
  is_platform_admin?: boolean;
  support_org_id?: string | null;
}

/** What the signed-in person actually has: drives which menu items show. */
export function useMyNav() {
  const { user } = useAuth();
  const q = useQuery({
    queryKey: ["my-nav", user?.id],
    enabled: !!user,
    staleTime: 60_000,
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_my_nav" as any);
      if (error) throw error;
      return data as unknown as MyNav;
    },
  });
  return {
    nav: q.data ?? { is_manager: false, is_executive: false, was_asked: false },
    loading: q.isLoading,
  };
}
